export default __webpack_public_path__ + "static/media/slide4_w_bg.cab695ed.png";